<template>
  <div>
    <Backlink :back="{ name: 'clients.view', params: { id: client_id } }" />
    <h2>Prise de mesure</h2>
    <div class="row border border-1 rounded p-2">
      <p class="text-muted">
        {{ client?.nom }} {{ client?.prenoms }}, {{ GENRES[client.genre] }}
      </p>
    </div>
    <div class="row">
      <div class="mb-3 col-md-6">
        <label for="label_mesure" class="form-label fw-bold">Libellé de la mesure*</label>
        <input type="text" class="form-control" id="label_mesure" placeholder="Libellé de la mesure"
          v-model="formData.label" required>
          <small class="text-danger" v-if="errors['label']">{{ errors['label'][0] }}</small>
      </div>
      <hr />

      <div class="row">
        <div class="col-12 col-md-6 mb-3">
          <label for="genre_client" class="form-label">Mesures pour <strong>{{ GENRES[genre] || '...'
              }}</strong></label>
        </div>
      </div>

      <h3>Les mesures du client</h3>
      <div class="row" v-if="genre !== ''">
        <div class="mb-3 col-md-6" v-for="option in measurementsOptions" :key="option.short">
          <label :for="'mesure_' + option.short" class="form-label">{{ option.label }} ({{ option.short }})</label>
          <input type="number" step="1" class="form-control" :id="'mesure_' + option.short"
            :placeholder="'Mesure de ' + option.label" v-model="formData.mesures_data[option.short]">
        </div>
      </div>
      <div v-else>
        <p>Veuillez selectionner le genre pour saisir les mesures.</p>
      </div>

    </div>
    <div class="row">
      <div class="col-12 text-end">
        <button @click="$router.push({ name: 'clients.view', params: { id: client_id } })" type="button"
          class="btn btn-secondary"><i class="bi bi-x-circle me-1"></i>Annuler</button>
        <button @click="save" type="button" :disabled="genre == ''" class="btn btn-primary mx-1"><i
            class="bi bi-check-circle me-1"></i>Enregistrer</button>
      </div>
    </div>
  </div>
</template>

<script>
import formMixin from '@/mixins/formMixin';
import { HumanGenre } from '@/enums/HumanGenre';
import Backlink from '@/components/partials/Backlink.vue';
export default {
  name: 'MeasurementsForm',
  mixins: [formMixin],
  props: {
    client_id: {
      type: Number,
      required: true
    },
    genre: {
      type: String,
      default: ''
    }
  },
  components: {
    Backlink
  },
  data() {
    return {
      GENRES: HumanGenre,
      measurementsOptions: [],
      defaultData: {
        label: 'Initial',
        mesures_data: {}
      },
      url: '/mesures',
      client: {}
    }
  },
  watch: {
    genre() {
      this.getMeasurementsOptions();
    },
    item: {
      immediate: true,
      handler() {
        if (this.item && this.item.mesures_data) {
          console.log(this.item.mesures_data);
          this.formData.mesures_data = {};
          this.item.mesures_data.forEach((val) => {
            this.formData.mesures_data[val.short] = val.value;
          });
        }

        // console.log('Item changed:', this.item);
        console.log('Form Data:', this.formData);
      }
    },
    client_id() {
      this.getClient();
    }
  },

  methods: {

    getMeasurementsOptions() {
      // Fetch measurements from API or store
      this.$api.get(`/unites?genre=${this.genre}`)
        .then(response => {
          this.measurementsOptions = response.data.data;
        });
    },

    getClient() {
      this.$api.get(`/clients/${this.client_id}`)
        .then(response => {
          this.client = response.data.data;
        })
        .catch(error => {
          console.log(error);
        })
        ;
    },

    beforeSave() {
      this.formData.client_id = this.client_id;
    }
  },
}
</script>

<style scoped>
form div {
  margin-bottom: 8px
}
</style>
